if ($("body.page-template-archive-actus").length) {

    //On select department
    let selectDepartements = $('input[data-taxonomy=departements]');
    selectDepartements.change(function () {
        let isParentTerm = $(this).data("parent")
        let selectedParents = $('input[data-taxonomy=departements][data-parent="1"]:checked')
        let selectedEpci = $('input[data-taxonomy=departements][data-parent="0"]:checked')
        let checkedParents = $('.checked input[data-taxonomy=departements][data-parent="1"]')
        let departmentParents = $('input[data-taxonomy=departements][data-parent="1"]')
        let currentInput = $(this)
        if (isParentTerm) {
            let epcis = $('input[data-taxonomy=departements][data-parent-term-id]')

            if (selectedParents.length) {
                //Uncheck all Epci
                epcis.parents('.input-checkbox').hide()
                epcis.parents('.input-checkbox').removeClass('checked');
                epcis.prop('checked', false);

                let termId = currentInput.data('term-id')
                let selectedEpci = $('input[data-taxonomy=departements][data-parent-term-id='+termId+']')
                selectedEpci.parents('.input-checkbox').show()

                departmentParents.each(function () {
                    if ($(this).attr('id') != currentInput.attr('id')) {
                        $(this).parents('.input-checkbox').removeClass('checked');
                        $(this).prop('checked', false);
                    }
                })
            } else {
                //Uncheck all Epci
                epcis.parents('.input-checkbox').removeClass('checked').hide();
                epcis.prop('checked', false);
            }
        } else {
            // console.log(checkedParents.length)
           if (checkedParents.length) {
               // console.log(selectedEpci.length)
               if (selectedEpci.length) {
                   selectedParents.prop('checked', false);
               } else {
                   console.log('vide')
                   checkedParents.prop('checked', true);
               }
               // selectedParents.prop('checked', false);
           } else {
               // selectedParents.prop('checked', true);
           }
        }
    })
}


export function initDepartment() {
    if (!$("body.page-template-archive-actus").length) return

    let selectedParent = $('input[data-taxonomy=departements][data-parent="1"]:checked').eq(0);
    let epcis = $('input[data-taxonomy=departements][data-parent="0"]');

    if (selectedParent.length) {
        let termId = selectedParent.data('term-id')
        let selectedEpci = $('input[data-taxonomy=departements][data-parent-term-id='+termId+']')
        selectedEpci.parents('.input-checkbox').show()
        epcis.parents('.input-checkbox').removeClass('checked');
        epcis.prop('checked', false);
    } else {
        //Uncheck all Epci
        epcis.parents('.input-checkbox').removeClass('checked').hide();
        epcis.prop('checked', false);
    }
}
